import { storableError } from '../../util/errors';
import { fetchSeoPerformerSubpage } from '../../util/seoDiscoveryFetch';

export const FETCH_PERFORMER_SUBPAGE_REQUEST = 'app/SeoDiscoveryPerformerSubpage/FETCH_REQUEST';
export const FETCH_PERFORMER_SUBPAGE_SUCCESS = 'app/SeoDiscoveryPerformerSubpage/FETCH_SUCCESS';
export const FETCH_PERFORMER_SUBPAGE_ERROR = 'app/SeoDiscoveryPerformerSubpage/FETCH_ERROR';

const initialState = {
  payload: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PERFORMER_SUBPAGE_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_PERFORMER_SUBPAGE_SUCCESS:
      return { ...state, fetchInProgress: false, payload };
    case FETCH_PERFORMER_SUBPAGE_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_PERFORMER_SUBPAGE_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_PERFORMER_SUBPAGE_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_PERFORMER_SUBPAGE_ERROR, payload: storableError(e) });

export const loadData = (params, search, config) => dispatch => {
  const { performerSlug, subpageSlug } = params || {};
  if (!performerSlug || !subpageSlug) {
    return Promise.resolve();
  }
  dispatch(fetchRequest());
  return fetchSeoPerformerSubpage(performerSlug, subpageSlug)
    .then(data => dispatch(fetchSuccess(data)))
    .catch(e => {
      dispatch(fetchError(e));
      throw e;
    });
};
